module.exports = __webpack_public_path__ + "static/img/mob-2.cdfb828e.jpeg";